import { Stack, styled, Box } from '@mui/material'
import { SelectedBadge } from '$common/badge'

const Container = styled(Stack)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  align-items: center;
`

export function MediaWrapper({
  selected,
  children,
}: {
  selected: boolean
  children: JSX.Element | JSX.Element[]
}) {
  return (
    <Container>
      {selected && (
        <Box sx={{ position: 'absolute', top: 5, right: 5, zIndex: 1 }}>
          <SelectedBadge />
        </Box>
      )}
      {children}
    </Container>
  )
}
